import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["key"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { Autocomplete, TextField, Typography, createFilterOptions } from '@mui/material';
import React from 'react';
import useStyles from './attachBillModalStyles';
const labelOf = property => (property === null || property === void 0 ? void 0 : property.propertyAddress) || (property === null || property === void 0 ? void 0 : property.propertyName) || 'Unnamed property';

// Typed text matches the address OR the name — the placeholder promises both.
const filterOptions = createFilterOptions({
  stringify: property => "".concat(property.propertyAddress || '', " ").concat(property.propertyName || '')
});

/**
 * A property, found by typing. A company can have hundreds of properties, and a plain select makes a
 * person scroll for the one a bill names; searching by street or name finds it in a keystroke or two.
 * Each option shows the address first, since that is what the bill prints, and the property's name
 * beneath it when it has a different one.
 */
export const AttachPropertyPicker = _ref => {
  let id = _ref.id,
    properties = _ref.properties,
    value = _ref.value,
    onChange = _ref.onChange,
    label = _ref.label,
    placeholder = _ref.placeholder,
    disabled = _ref.disabled,
    autoFocus = _ref.autoFocus,
    describedBy = _ref.describedBy;
  const classes = useStyles();
  const selected = properties.find(property => property.propertyId === value) || null;
  return /*#__PURE__*/React.createElement(Autocomplete, {
    id: id,
    options: properties,
    value: selected,
    onChange: (_, property) => onChange((property === null || property === void 0 ? void 0 : property.propertyId) || ''),
    getOptionLabel: labelOf,
    filterOptions: filterOptions,
    isOptionEqualToValue: (option, current) => option.propertyId === current.propertyId,
    disabled: disabled,
    autoHighlight: true,
    renderOption: (_ref2, property) => {
      let key = _ref2.key,
        optionProps = _objectWithoutProperties(_ref2, _excluded);
      return /*#__PURE__*/React.createElement("li", _extends({}, optionProps, {
        key: property.propertyId
      }), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Typography, {
        variant: "body2"
      }, labelOf(property)), property.propertyName && property.propertyName !== property.propertyAddress && /*#__PURE__*/React.createElement(Typography, {
        variant: "caption",
        color: "light"
      }, property.propertyName)));
    },
    noOptionsText: "No property matches that",
    renderInput: params => /*#__PURE__*/React.createElement(TextField, _extends({}, params, {
      label: label,
      placeholder: placeholder,
      autoFocus: autoFocus,
      className: classes.picker,
      inputProps: _objectSpread(_objectSpread({}, params.inputProps), {}, {
        'aria-describedby': describedBy
      })
    }))
  });
};